import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaPerformanceFee = React.lazy(() =>
    import('../NebulaPerformanceFee')
);
const nebulaPerformanceFeeRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_PERFORMANCE_FEE_PAGE,
        element: <NebulaPerformanceFee />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaPerformanceFeeRoutesRegistry;
